<template>

	<section ref="targetDom" class="product_list_wrap">

		<!-- <div class="news" v-html="news"></div> -->

		<nav :class="[classFixed?'fixedTop':'','p_l_nav']">
			<span
			v-for="(item,index) in secondNav"
			:key="index"
			@click="clickSecondNavItem(index)"
			:class="['nav_btn',currentIndex === index ? 'active':'']"
      >
				{{item.ClassifyName}}
			</span>
		</nav>

		<section ref="initOst" :class="[classFixed?'padding':'','product_exhibition']">
			<div class="floor-item">
				<p>{{secondNavItem.ClassifyName}}</p>
				<ul>
					<li
					class="product-list-item"
					v-for="(item,index) in itemList"
          :key="index"
					@click="goToDetailPage(item)"
					>
						<img v-if="item.GoodsLogoUrl!=''" :src="item.GoodsLogoUrl" alt="图片加载失败">
						<img v-else src="../../assets/12.jpg" alt="大床房">

						<div class="goods_info">
							<h3>{{item.ScopeName}}</h3>
							<span><i class="red-text iconfont icon-renminbi"></i>{{item.AdultPrice}}</span>
							<span :class="['text_nowrap','']">{{item.Description}}</span>
						</div>
					</li>
				</ul>
			</div>
		</section>

	</section>
</template>

<script>
	// var TIMER = null;
	export default {
		name: 'product-list',
		props: {
      secondNav:{
        type:Array,
        required:true,
      },
      itemList:{
        type:Array,
        required:true,
      },
      secondNavItem:{
        type:Object,
        required:true,
      }
		},
		data () {
			return {
        //定位元素
        // homeEl:null,
        positionEl:null,
				// businessid: 1,
				// scopeid: 0, //业务总分类ID
        scopeClassify:0,
        currentIndex:0,
				classFixed: false,
				news:"",
			}
		},
		components: {

		},
    created () {

    },

		methods: {

      //监听元素scroll
      monitorScroll(){
        var homeEl = document.getElementsByClassName('home');

        homeEl[0].addEventListener('scroll',()=>{
          // console.log(homeEl[0].scrollTop);
          // console.log(this.$refs.targetDom.offsetTop);
          if(homeEl[0].scrollTop >= this.$refs.targetDom.offsetTop){
            this.classFixed = true;
          } else{
            this.classFixed = false;
           }
        },false)
      },

      //选择二级导航分类
      clickSecondNavItem (index) {

        var homeEl = document.getElementsByClassName('home'),
            tost = this.$refs.targetDom.offsetTop + 2,
            hst = homeEl[0].scrollTop-tost;

            if(hst > tost){
              homeEl[0].scrollTo(0,tost);
            }

        // console.log(homeEl[0]);
        this.currentIndex = index;
        // console.log('scopeClassify=>'+this.scopeClassify);
        // console.log('secondNav[index].ID=>'+this.secondNav[index].ID);
        if(this.scopeClassify != this.secondNav[index].ID){
          this.scopeClassify = this.secondNav[index].ID;
          // console.log('currentIndex=>'+this.currentIndex);
          // console.log('scopeClassify=>'+this.scopeClassify);
          // console.log(this.secondNav);
          // console.log(this.scopeClassify);
          // console.log('secondNav[index].ID=>'+this.secondNav[index].ID);
          this.$emit("changedScopeClassify",this.scopeClassify);
        }else{

        }
      },

			//跳转--------------------------------------
			goToDetailPage(item) {
        this.classFixed = false;
				// console.log(that.itemList);
				this.$router.push({
					// name: "detail-page",
					// params:{
					// 	// id:item.ID,
					// 	item:item,
					// 	scopeid:this.scopeid,
					// },
          path:'/detail-page',
          query:{
            goodsId:item.ID,
          }
				});
			},

		},

		mounted() {  //组件挂载后,此方法执行后,页面显示
      this.monitorScroll();
		},
	}
</script>

<style scoped lang="less">
  @import "../../style/variable.less";

	.product_list_wrap {
    .flex_wrap(initial,initial,initial,initial);
		.border-T(2px);
		flex: 1;
    height: auto;
		z-index: 10;
    color: @floorTextColor;
		background-color: @floorBgc;
    .p_l_nav {
    	max-width: @productListNavW;
    	flex: 0 0 @productListNavW;
      .nav_btn {
      	width: 100%;
        text-overflow: clip;
        white-space: nowrap;
      	text-align: center;
      	font-size: .35rem;
      	letter-spacing: 1px;
      	display: block;
      	line-height: .8rem;
      	border-right: 1px solid #888;
      	border-bottom: 1px solid #888;
      	background-color: #fff;
      	box-sizing: border-box;
      	text-overflow: clip;
      	overflow: hidden;
      	padding-left: 6px;
      	letter-spacing: 4px;
        line-height: 1.4rem;
      }
      .active {
      	background-color: #F8F8F8;
      	color: #E77618;
      	border-right: none;
      	border-left: 3px solid #E77618;
      }
    }
    .product_exhibition {
    	flex: 1;
    	// overflow: auto;
    	margin-top: 2px;
      .floor-item {
      	margin: .3rem;
      	padding: 5%;
      	// background-color: #fff;
      	z-index: 1;
        &>p:first-child {
          background-color: #E77618;
          padding-left: 5px;
          color: #fff;
          font-weight: 600;
        }
        &>ul {
          margin-top: 10px;
          .product-list-item {
            .flex_wrap(space-between,center,initial,initial);
          	margin-top: 15px;
            &>.goods_info{
              .flex_wrap(initial,flex-end,nowrap,column);
              flex: 1;
              .iconfont{
                margin: 0 5px 0 0;
              }
            }
            h3 {
            	text-align: right;
            	color: #666;
            	text-shadow: 0 0 1px rgba(0, 0, 0, .4);
            	padding-right: 5px;
            }
            span{
              max-width: 10em;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 5px;
              white-space: nowrap;
            }
            img {
            	width: 1.6rem;
            	max-width: 1.6rem;
            	height: 1.6rem;
            	padding: .16rem;
            	border: 1px solid #888;
              text-align: center;
            }
          }
        }
      }
    }
	}


	.padding {
		padding-left: 2rem;
	}

	.floor-item>p:first-child,.floor-item>ul>li {
	// .floor-item>p:first-child,.floor-item,.floor-item>ul>li {
		.radius();
		.shadow();
	}



	.product-list-item {
		justify-content: space-between;
		border-radius: 5px;
		padding: .2rem;
	}

  .news{
    flex: 1;
  }


</style>



// WEBPACK FOOTER //
// src/components/child-components/ProductListTmp.vue